import * as React from "react"
import type { SVGProps } from "react"
const SvgPercent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M15 16.79q.63 0 1.06-.44.45-.45.44-1.06 0-.62-.44-1.07A1.5 1.5 0 0 0 15 13.8q-.63 0-1.06.43a1.5 1.5 0 0 0-.44 1.07q0 .62.44 1.06.43.44 1.06.44m-7.25-.25a1 1 0 0 0 .7.27 1 1 0 0 0 .7-.27l7.1-7.1a1 1 0 0 0 .28-.7 1 1 0 0 0-.28-.7 1 1 0 0 0-.7-.28 1 1 0 0 0-.7.28l-7.1 7.1a1 1 0 0 0-.27.7q0 .42.27.7M9 10.79q.63 0 1.06-.44.45-.45.44-1.06 0-.62-.44-1.07A1.5 1.5 0 0 0 9 7.8q-.63 0-1.06.43A1.5 1.5 0 0 0 7.5 9.3q0 .62.44 1.06.43.44 1.06.44" />
    <path
      fillRule="evenodd"
      d="M5 21.29q-.82 0-1.41-.6A2 2 0 0 1 3 19.3v-14q0-.82.59-1.42A2 2 0 0 1 5 3.3h14q.83 0 1.41.58.6.6.59 1.42v14q0 .83-.59 1.4a2 2 0 0 1-1.41.6zm0-16v14h14v-14z"
    />
  </svg>
)
export default SvgPercent
